var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadCrumbArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4774_10082)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78633 6.20104C7.93789 6.37154 7.93789 6.62847 7.78633 6.79896L4.22924 10.8007C4.11917 10.9245 4.13032 11.1141 4.25416 11.2242C4.37799 11.3343 4.56761 11.3231 4.67769 11.1993L8.23478 7.19758C8.58841 6.79975 8.58841 6.20025 8.23478 5.80242L4.67769 1.80069C4.56761 1.67686 4.37799 1.6657 4.25416 1.77578C4.13032 1.88585 4.11917 2.07547 4.22924 2.19931L7.78633 6.20104Z",
    fill: "#5B5C5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4774_10082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadCrumbArrow);
export default __webpack_public_path__ + "static/media/BreadCrumbArrow.bc4c66c441a55dc4f417a4ed54bd429e.svg";
export { ForwardRef as ReactComponent };